(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reaper-announcements')) customElements.define('reaper-announcements', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.slides = [...this.querySelectorAll('.announcement-bar__slide')];
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = new Set();
      this.show(0);
      this.addEventListener('mouseenter',()=>this.pause('hover'),options);
      this.addEventListener('mouseleave',()=>this.resume('hover'),options);
      this.addEventListener('focusin',()=>this.pause('focus'),options);
      this.addEventListener('focusout',event=>{if(!this.contains(event.relatedTarget))this.resume('focus');},options);
      this.addEventListener('pointerdown',()=>this.pause('pointer'),options);
      window.addEventListener('pointerup',()=>this.resume('pointer'),options);
      window.addEventListener('pointercancel',()=>this.resume('pointer'),options);
      document.addEventListener('visibilitychange',()=>document.hidden?this.pause('hidden'):this.resume('hidden'),options);
      this.motion.addEventListener('change',()=>this.schedule(),options);
      document.addEventListener('shopify:block:select',event=>{const slide=event.target.closest('.announcement-bar__slide');if(this.slides.includes(slide)){this.pause('editor');this.show(this.slides.indexOf(slide));}},options);
      document.addEventListener('shopify:block:deselect',()=>this.resume('editor'),options);
      this.observer = new ResizeObserver(()=>this.fit());this.observer.observe(this);
      this.fit();this.schedule();
    }
    fit(){this.style.setProperty('--announcement-fit','11px');const width=Math.max(...this.slides.map(s=>s.querySelector('.announcement-bar__text')?.scrollWidth||0),1);this.style.setProperty('--announcement-fit',Math.min(11,11*(this.clientWidth-16)/width)+'px');}
    show(index){this.index=index;this.slides.forEach((slide,i)=>{slide.setAttribute('aria-hidden',String(i!==index));slide.inert=i!==index;});}
    pause(reason){this.paused.add(reason);clearTimeout(this.timer);}
    resume(reason){this.paused.delete(reason);this.schedule();}
    schedule(){clearTimeout(this.timer);if(this.motion.matches||this.paused.size||this.slides.length<2||document.hidden)return;this.timer=setTimeout(()=>{this.show((this.index+1)%this.slides.length);this.schedule();},Number(this.dataset.seconds)*1000+400);}
    disconnectedCallback(){clearTimeout(this.timer);this.observer?.disconnect();this.controller?.abort();}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
if (!customElements.get('reaper-recommendation-carousel')) {
  customElements.define('reaper-recommendation-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.reaper-recommendations__track');
      this.previous = this.querySelector('.reaper-recommendations__arrow--prev');
      this.next = this.querySelector('.reaper-recommendations__arrow--next');
      if (!this.track || !this.previous || !this.next) return;
      this.update = () => {
        const end = this.track.scrollWidth - this.track.clientWidth;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= end - 2;
        const image = this.track.querySelector('.reaper-recommendations__photo');
        if (image) this.style.setProperty('--arrow-y', `${image.getBoundingClientRect().height / 2}px`);
      };
      const move = direction => {
        this.track.scrollBy({left: direction * (this.track.clientWidth + 8), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.previous.addEventListener('click', () => move(-1), {signal});
      this.next.addEventListener('click', () => move(1), {signal});
      this.track.addEventListener('scroll', this.update, {passive:true, signal});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.mutations = new MutationObserver(this.update);
      this.mutations.observe(this.track, {childList:true});
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.mutations?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reaper-flow-catalog"] && !Shopify.designMode) return;
  try {
    
  const initCatalog = (root = document) => {
    root.querySelectorAll('.rf-filters').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const sort = form.querySelector('[data-rf-sort]');
      sort.addEventListener('change', () => {
        const stock = sort.value === 'in-stock';
        form.querySelector('[data-rf-sort-value]').value = stock || sort.value === 'default' ? sort.dataset.defaultSort : sort.value;
        if (stock) {
          const availability = form.querySelectorAll('input[name="filter.v.availability"]');
          availability.forEach(input => { input.checked = input.value === '1'; if (input.checked) input.disabled = false; });
          if (!Array.from(availability).some(input => input.value === '1')) {
            const input = document.createElement('input');
            input.type = 'hidden'; input.name = 'filter.v.availability'; input.value = '1';
            form.append(input);
          }
        }
        form.requestSubmit();
      });
      form.querySelectorAll('[data-rf-submit]').forEach(input => input.addEventListener('change', () => form.requestSubmit()));
      form.addEventListener('submit', () => form.querySelectorAll('input[type=number]').forEach(input => { if (!input.value) input.disabled = true; }));
      form.querySelectorAll('[data-rf-min]').forEach(button => {
        const min = form.querySelector('.rf-prices input');
        const max = form.querySelectorAll('.rf-prices input')[1];
        button.classList.toggle('is-active', min.value === button.dataset.rfMin && max.value === button.dataset.rfMax);
        button.addEventListener('click', () => {
          min.disabled = false; max.disabled = false;
          min.value = button.dataset.rfMin; max.value = button.dataset.rfMax;
          form.requestSubmit();
        });
      });
      const details = form.querySelector('.rf-filter-drawer');
      const desktop = matchMedia('(min-width: 1000px)');
      const resize = () => { details.open = desktop.matches; };
      desktop.addEventListener('change', resize); resize();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initCatalog()); else initCatalog();
  document.addEventListener('shopify:section:load', event => initCatalog(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reaper-product-reviews"] && !Shopify.designMode) return;
  try {
    

function setupReaperReviews(root=document){
 root.querySelectorAll('.rr').forEach(section=>{
  const toggle=section.querySelector('[data-review-toggle]');
  if(toggle.dataset.ready)return;
  toggle.dataset.ready='true';
  const cards=Array.from(section.querySelectorAll('.rr-grid > .rr-card'));
  cards.forEach((card,index)=>{
   const comment=card.querySelector('[data-review-comment]');
   const read=card.querySelector('[data-review-read]');
   if(!comment||!read||comment.textContent.trim().length<=140)return;
   comment.id=section.id+'-comment-'+index;
   read.setAttribute('aria-controls',comment.id);
   comment.classList.add('is-collapsed');read.hidden=false;
   read.addEventListener('click',()=>{
    const expanded=read.getAttribute('aria-expanded')!=='true';
    read.setAttribute('aria-expanded',String(expanded));
    read.textContent=expanded?'LEER MENOS':'LEER MÁS';
    comment.classList.toggle('is-collapsed',!expanded);
   });
  });
  const more=section.querySelector('[data-review-more]');
  // Mostrar las reseñas completas: no ocultar tarjetas tras el cuarto comentario.
  if(more)more.hidden=true;
  const wrap=section.querySelector('.rr-form-wrap');
  const form=wrap.querySelector('form');
  const open=!!wrap.querySelector('[data-review-result]')||location.hash==='#'+form.id;
  wrap.hidden=!open;
  toggle.setAttribute('aria-expanded',String(open));
  toggle.addEventListener('click',event=>{
   event.preventDefault();wrap.hidden=!wrap.hidden;toggle.setAttribute('aria-expanded',String(!wrap.hidden));
   if(!wrap.hidden)wrap.querySelector('input:not([type="hidden"])')?.focus({preventScroll:true});
  });
 });
}
setupReaperReviews();
document.addEventListener('shopify:section:load',event=>setupReaperReviews(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reaper-reference-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reaper-hero-scroll')) {
    customElements.define('reaper-hero-scroll', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        const section = this.closest('.shopify-section');
        let next = section?.nextElementSibling;
        while (next && (!next.matches('.shopify-section') || !next.getClientRects().length)) next = next.nextElementSibling;
        if (!button || !next) return;
        button.hidden = false;
        this.abort?.abort();
        this.abort = new AbortController();
        button.addEventListener('click', () => {
          const header = document.querySelector('header-component');
          const offset = header?.getBoundingClientRect().height || 0;
          let scroller = section.parentElement;
          while (scroller && !(/auto|scroll/.test(getComputedStyle(scroller).overflowY) && scroller.scrollHeight > scroller.clientHeight)) scroller = scroller.parentElement;
          const top = next.getBoundingClientRect().top + (scroller ? scroller.scrollTop - scroller.getBoundingClientRect().top : window.scrollY) - offset;
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          (scroller || window).scrollTo({ top, behavior: reduced ? 'instant' : 'smooth' });
          next.setAttribute('tabindex', '-1');
          next.focus({ preventScroll: true });
        }, { signal: this.abort.signal });
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reaper-reference-journal"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('reaper-journal'))customElements.define('reaper-journal',class extends HTMLElement{
connectedCallback(){if(this._ready)return;this._ready=true;const t=this.querySelector('.rj__track'),p=this.querySelector('[data-prev]'),n=this.querySelector('[data-next]');const update=()=>{p.disabled=t.scrollLeft<2;n.disabled=t.scrollLeft>=t.scrollWidth-t.clientWidth-2};const move=d=>{const card=t.querySelector('.rj__card');if(card)t.scrollBy({left:d*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(t).gap)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})};p.addEventListener('click',()=>move(-1));n.addEventListener('click',()=>move(1));t.addEventListener('scroll',update,{passive:true});this._observer=new ResizeObserver(update);this._observer.observe(t);update()}
disconnectedCallback(){this._observer?.disconnect();this._ready=false}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reaper-reference-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reaper-discover-carousel')) {
    customElements.define('reaper-discover-carousel', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('.reaper-discover__products');
        const previous = this.querySelector('[data-discover-prev]');
        const next = this.querySelector('[data-discover-next]');
        const navigation = this.querySelector('.reaper-discover__navigation');
        if (!track || !previous || !next) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const update = () => {
          const maximum = track.scrollWidth - track.clientWidth;
          navigation.hidden = maximum <= 2;
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= maximum - 2;
        };
        const move = (direction) => {
          const step = track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
          track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        track.addEventListener('scroll', update, { ...options, passive: true });
        this.observer?.disconnect();
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
